import {User} from '@/oauth/User';
import {SecurityRequestBase} from '@/oauth/SecurityRequestBase';
import {AuthToken} from '@/oauth/AuthToken';
import {AxiosResponse} from 'axios';
import router from '@/router';
import KeShangSelect from "@/views/KeShangSelect.vue";
import {TokenTime} from "@/oauth/TokenTime";

export class CodeResp {
    sessionId = '';
    sig = '';
    token = '';
}

export class AuthTokenDto {
    private static storageKey = 'AuthToken';
    private static url = '/auth';

    private static check = false;


    //todo:版本号
    public static version = 10;


    public static save(a: AuthToken) {
        // window.sessionStorage.setItem(this.storageKey, JSON.stringify(a));//潘大源码
        window.localStorage.setItem(this.storageKey, JSON.stringify(a));
    }

    public static hook(r: AxiosResponse<any>) {
        const a = (r.headers[this.storageKey] || '');
        if (a !== '') {
            this.save(AuthToken.of(a));
        }
    }

    public static isSet(): boolean {
        const b = this.getFromStorage().access_token.match(/.+\..+\..+/) !== null;
        return b;
    }

    public static async getTokenByLogin(user: User): Promise<AuthToken> {
        if (user.username === '') {
            throw '用户名不能为空';
        }
        if (user.password === '') {
            throw '密码不能为空';
        }
        const url = this.url + '/login';
/*        user. version=KeShangSelect.thisMachineAppVersionCode.toString();
        user.sidemodel=  localStorage.getItem("sidemodel");*/
        const fullUrl = SecurityRequestBase.getFullUrl(url, user);
        const response = await SecurityRequestBase.getData(fullUrl);
        //todo
        const tokenizer=  new TokenTime();
        tokenizer.token=response.access_token;
        tokenizer.userid=user.username;
        tokenizer.version=KeShangSelect.thisMachineAppVersionCode.toString();
        tokenizer.sidemodel=localStorage.getItem("sidemodel");
        await SecurityRequestBase.post(this.url + '/updateTokenTime', tokenizer);
        try {
            return AuthToken.of(response);
        } catch (e) {
            throw 'token无效';
        }
    }






    // public static async getTokenByLogin1(user: User): Promise<AuthToken> {
    //     if (user.username === '') {
    //         throw '用户名不能为空';
    //     }
    //     console.log("--------------")
    //     const url = this.url + '/login';
    //     const fullUrl = SecurityRequestBase.getFullUrl(url, user);
    //     const response = await SecurityRequestBase.getData(fullUrl);
    //     try {
    //         return AuthToken.of(response);
    //     } catch (e) {
    //         throw 'token无效';
    //     }
    // }

    public static async getTokenBySMSLogin(user: User): Promise<AuthToken> {
        if (user.username === '') {
            throw '用戶名不能为空';
        }
        if (user.code === '') {
            throw '验证码不能为空';
        }
        const url = this.url + '/smslogin';
        const fullUrl = SecurityRequestBase.getFullUrl(url, user);
        const response = await SecurityRequestBase.getData(fullUrl);
        try {
            return AuthToken.of(response);
        } catch (e) {
            throw 'token无效';
        }
    }

/*    public static async getTokenByRegister(user: User, cr: CodeResp): Promise<AuthToken> {
        if (user.username === '') {
            throw '用戶名不能为空';
        }
        if (user.password === '') {
            throw '密码不能为空';
        }
        if (cr.token === '') {
            throw '请完成滑条验证';
        }
        user.sidemodel=localStorage.getItem("sidemodel");
        user.version=localStorage.getItem("sidemodel");
        const url = this.url + '/register';
        const fullUrl = SecurityRequestBase.getFullUrl(url, {...user, ...cr});
        const response = await SecurityRequestBase.getData(fullUrl);
        try {
            return AuthToken.of(response);
        } catch (e) {
            throw 'token无效';
        }
    }*/

//Skw58484371

        public static async getTokenByRegister(user: User, cr: CodeResp): Promise<AuthToken> {
        if (user.username === '') {
            throw '用戶名不能为空';
        }
        if (user.password === '') {
            throw '密码不能为空';
        }
        user.sidemodel=localStorage.getItem("sidemodel");
        user.version=localStorage.getItem("sidemodel");
        const url = this.url + '/registernew';
        const fullUrl = SecurityRequestBase.getFullUrl(url, {...user, ...cr});
        const response = await SecurityRequestBase.getData(fullUrl);
        try {
            return AuthToken.of(response);
        } catch (e) {
            throw 'token无效';
        }
    }






    public static async getTokenByRefreshToken(refreshToken = this.getFromStorage().refresh_token): Promise<AuthToken> {
        const url = this.url + '/refreshToken';
        const response = await SecurityRequestBase.getData(url, {refreshToken});
        try {
            const authToken = AuthToken.of(response);
            this.save(authToken);
            return authToken;
        } catch (e) {
            throw 'refreshToken无效';
        }
    }

    public static getOrLogin(): AuthToken {
        try {
            if (!this.check || this.isSet()) {
                const fromStorage = this.getFromStorage();
                fromStorage.getClam();
                return fromStorage;
            } else {
                router.push({name: 'login'});
                throw '未激活,请先激活';
            }
        } catch (e) {
            router.push({name: 'login'});
            return new AuthToken();
        }

    }

    public static getFromStorage(): AuthToken {
        // const item = window.sessionStorage.getItem(this.storageKey); 潘大源码
        const item = window.localStorage.getItem(this.storageKey);
        if (item !== null) {
            try {
                const parse = JSON.parse(item);
                return AuthToken.of(parse);
            } catch (e) {
                return AuthToken.of('');
            }
        } else {
            localStorage.removeItem("user");
            console.warn('未能从本地存储获取令牌...');
            return AuthToken.of('');
        }
    }

    public static logout() {
        // window.sessionStorage.removeItem(this.storageKey); 潘大源码
        // window.localStorage.removeItem(this.storageKey);
    }

    // public static async send(receiver: string): Promise<unknown> {
    //     const url = this.url + '/send';
    //     const fullUrl = SecurityRequestBase.getFullUrl(url, {receiver});
    //     const response = await SecurityRequestBaspublic static async send(receiver: string): Promise<unknown> {
    //         const url = this.url + '/send';
    //         const fullUrl = SecurityRequestBase.getFullUrl(url, {receiver});
    //         const response = await SecurityRequestBase.getData(fullUrl);
    //         return response;
    //     }e.getData(fullUrl);
    //     return response;
    // }

    public static async send(receiver: string): Promise<unknown> {
        const url = this.url + '/send';
        const fullUrl = SecurityRequestBase.getFullUrl(url, {receiver});
        const response = await SecurityRequestBase.getData(fullUrl);
        return response;
    }


    public static async registerSend(receiver: string): Promise<unknown> {
        const url = this.url + '/registerSend';
        const fullUrl = SecurityRequestBase.getFullUrl(url, {receiver});
        const response = await SecurityRequestBase.getData(fullUrl);
        return response;
    }


     static async isTokenSurvival(username: string): Promise<TokenTime>{
        const url = this.url + '/getTokenTime';
        const fullUrl = SecurityRequestBase.getFullUrl(url, {username});
        const response = await SecurityRequestBase.getData(fullUrl);
         return  TokenTime.of(response)
    }


    static async insertTokenTime(username: string){
        const tokenizer=  new TokenTime();
        tokenizer.userid=username;
        tokenizer.version=KeShangSelect.thisMachineAppVersionCode.toString();
        tokenizer.sidemodel=localStorage.getItem("sidemodel");
        await SecurityRequestBase.post(this.url + '/insertTokenTime', tokenizer);
    }



    static async boolPasswordTrue(useri: User): Promise<boolean>{
        const url = this.url + '/boolpw';
        const fullUrl = SecurityRequestBase.getFullUrl(url, useri);
        const response = await SecurityRequestBase.getData(fullUrl);
        return  response;
    }


    static async boolInsertOrUpdateTokenTime(tokenizer: TokenTime){
        const response= await SecurityRequestBase.post(this.url + '/boolInsertOrUpdateTokenTime', tokenizer);
        return response;
    }

    //  static async flushPage(userName: string): Promise<any>{
    //    const response = await SecurityRequestBase.getData(this.url+'/flushPage?username='+userName)
    //      return response
    // }



}
